import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"darhboard\"><rect id=\"Rectangle\" x=\"4\" y=\"4\" width=\"6\" height=\"6\" rx=\"1\" fill=\"currentColor\" stroke=\"currentColor\" stroke-linejoin=\"round\"></rect><rect id=\"Rectangle_2\" x=\"4\" y=\"14\" width=\"6\" height=\"6\" rx=\"1\" fill=\"currentColor\" stroke=\"currentColor\" stroke-linejoin=\"round\"></rect><rect id=\"Rectangle_3\" x=\"14\" y=\"14\" width=\"6\" height=\"6\" rx=\"1\" fill=\"currentColor\" stroke=\"currentColor\" stroke-linejoin=\"round\"></rect><rect id=\"Rectangle_4\" x=\"14\" y=\"4\" width=\"6\" height=\"6\" rx=\"1\" fill=\"currentColor\" stroke=\"currentColor\" stroke-linejoin=\"round\"></rect></g>", 1)
  ])))
}
export default { render: render }